import React from 'react';
import PortalLogin from '@/components/PortalLogin';

// Partners Portal login. Uses the shared PortalLogin template. The Partners
// application is still under development, so only existing administrators
// proceed into the ecosystem; other valid users see a localized "coming soon"
// notice (gate handled inside PortalLogin).
const PartnersLogin = () => <PortalLogin portal="partners" />;

export default PartnersLogin;
